import { i18n } from "@translations/i18n";
import { StorageKeys } from "./LocalStorage";

export const getLanguage = () => {
  const lng = i18n.language;
  return lng || "en";
};

export const addI18Resource = (
  key: string,
  namespace: string,
  json: object,
  deep: boolean
) => {
  i18n.addResourceBundle(key, namespace, json, deep);
};

export const getLocalisationData = async () => {
  const etag: string = await localStorage.getItem(
    StorageKeys.LOCALIZATION_ETAG
  );
  const json: any = await localStorage.getItem(StorageKeys.LOCALISATION_JSON);
  return { etag, json };
};

export const updateLocalisationData = async (localisationData: {
  etag: string;
  json: any;
}) => {
  localStorage.setItem(StorageKeys.LOCALIZATION_ETAG, localisationData.etag);
  localStorage.setItem(StorageKeys.LOCALISATION_JSON, localisationData.json);
};
